import api from 'api';
import { OccupationType } from 'lib/enums';
import { EResponseTypes } from 'lib/types';

/**
 * Determine if an organization with the given name and type already exists.
 */
export const organizationAlreadyExists = async (
  organizationType: number,
  name: string
): Promise<boolean> => {
  const { exists }: EResponseTypes['organizations/:organizationType/exists'] =
    await api.get(`organizations/${organizationType}/exists`, { name });

  return exists;
};

export const isAdvertiserOrganization = (occupation: number) =>
  occupation === OccupationType.lawyer.value ||
  occupation === OccupationType.other_organization.value ||
  occupation === OccupationType.government_official.value;
